import db from '@/db';
import firebase from '@/firebase';

import {
  UPDATE_INFORMATION,
  UPDATE_BACKGROUND_IMAGE,
  ADD_QUESTION,
  UPDATE_QUESTION,
  ADD_ANSWER,
  REMOVE_QUESTION,
  REMOVE_ANSWER,
  UPDATE_ANSWER,
  RESET_QUIZ,
  REORDER_QUIZ_LIST,
  RESET_QUIZ_LIST,
  PUSH_QUIZ,
  SET_QUIZ,
  SET_NEW_QUIZ
 } from './mutations';

const state = {
  newQuiz: {
    title: "Quiz 2018",
    description: "La description de la categorie",
    order: 1,
    color: "#5432BB",
    results: {
      "good": "Bon texte",
      "average": "Average texte",
      "bad": "Mauvais texte",
    },
    background_image: "https://via.placeholder.com/1440x900?text=Optimum+size+1440px+x+900px",
    questions: [
      {
        question: "First Question",
        questionType: "radio",
        answers: [
          {
            answer: "First answer",
            points: 4,
            isBozo: false
          }
        ],
        resultat_texte: "Bonne pratique de l'industrie... bla bla"
      }
    ]
  },

  list: [],
  isSaving: false,
  quiz: null
};

const getters = {
  newQuiz: ({newQuiz}) => newQuiz,
  list: ({list}) => list,
  quiz: ({quiz}) => quiz,
  isSaving: ({isSaving}) => isSaving,
};

const mutations = {

  // List quizes from firestore

  [PUSH_QUIZ](state, quiz) {
    state.list.push(quiz);
  },

  [RESET_QUIZ_LIST](state) {
    state.list = [];
  },

  [REORDER_QUIZ_LIST](state) {
    function compare(a, b){
      // see https://www.sitepoint.com/sort-an-array-of-objects-in-javascript/
      // console.log(a.order, b.order);
      var aa = parseInt(a.order, 10);
      var bb = parseInt(b.order, 10);
      if (aa > bb) return 1;
      if (bb > aa) return -1;

      return 0;
    };
    state.list.sort(compare);
  },

  // Create a new quiz
  [RESET_QUIZ](state) {
    state.newQuiz = {
      title: "",
      description: "",
      color: "#fff",
      order: 0,
      results: {
        "good": "A remplir",
        "average": "A remplir",
        "bad": "A remplir",
      },
      background_image: "https://via.placeholder.com/1440x900?text=Optimum+size+1440px+x+900px",
      questions: []
    }
  },


  [UPDATE_INFORMATION](state, info) {
    state.newQuiz.title = info.title;
    state.newQuiz.description = info.description;
    state.newQuiz.order = info.order;
    state.newQuiz.color = info.color;
    state.newQuiz.results = info.results;
  },


  [UPDATE_BACKGROUND_IMAGE](state, url) {
    state.newQuiz.background_image = url;
  },

  [UPDATE_QUESTION](state, payload) {
    const question = state.newQuiz
            .questions[payload.questionIndex];

    question.question = payload.question;
    question.questionType = payload.questionType;
    question.resultat_texte = payload.resultat_texte;
    question.points = payload.points;
  },

  [ADD_ANSWER](state, questionIndex) {
    const answers = state.newQuiz.questions[questionIndex].answers;
    if (answers.length < 5) {
      answers.push({
        answer: "Anotha one!",
        points: 4
      });
    }
  },

  [REMOVE_QUESTION](state, questionIndex) {
    if (state.newQuiz.questions.length > 1) {
      state.newQuiz
        .questions
        .splice(questionIndex, 1);
    }
  },

  [REMOVE_ANSWER](state, payload) {
    const questionIndex = payload.questionIndex;
    const answerIndex = payload.answerIndex;

    const question = state.newQuiz.questions[questionIndex];

    if (question.answers.length > 1) {
      question.answers.splice(answerIndex, 1);
    }
  },

  [UPDATE_ANSWER](state, payload) {
    const questionIndex = payload.questionIndex;
    const answerIndex = payload.answerIndex;
    const answerText = payload.answer;
    const points = payload.points;

    const answer = state.newQuiz
      .questions[questionIndex]
      .answers[answerIndex];

    answer.points = points;
    answer.answer = answerText;
  },

  [ADD_QUESTION](state) {
    state.newQuiz
      .questions
      .push({
        question: "Question",
        points: 0,
        answers: []
      })
  },

  [SET_QUIZ](state, quiz) {
    state.quiz = quiz;
  },

  [SET_NEW_QUIZ](state, quiz) {
    state.newQuiz = quiz;
  }

};

const actions = {

  async create({commit, state}, payload) {
    // payload = {"id": quiID, "editMode": are_we_in_edit_mode, "refresh": should we reset quiz after update}
    // payload is optional here
    // const editMode = payload.editMode || false;
    state.isSaving = true;
    const editMode = !!payload.editMode;
    const shouldRefresh = !!payload.refresh;
    const user = firebase.auth().currentUser;
    if (user) {
      try {
          if (editMode == true) {
          // update to database
          const id = payload.id;
          await db.collection('quizes').doc(id).update({
            ...state.newQuiz,
            userId: user.uid
          });
          if (shouldRefresh == true) {
            commit(RESET_QUIZ);
          }
        } else {
          // save to database
          await db.collection('quizes').add({
            ...state.newQuiz,
            userId: user.uid
          });
        }
        state.isSaving = false;
      }
      catch (error) {
        console.log('Error: ' + error);
        state.isSaving = false;
      }


    } else {
      alert('Unauthorized');
    }
  },

  async list({commit}) {
    commit(RESET_QUIZ_LIST);

    await db.collection('quizes').onSnapshot( snapshot => {
       snapshot.docChanges().forEach(function(change) {
        if (change.type === "added") { // needs documentation
          commit(PUSH_QUIZ, {
            id: change.doc.id,
            ...change.doc.data()
          });
          commit(REORDER_QUIZ_LIST);
        }
      });
    });
  },

  async get({commit, state}, payload) {
    // payload = {"id": quiID, "editMode": are_we_in_edit_mode}
    const id = payload.id;
    const editMode = payload.editMode;
    const quiz = await db.collection('quizes').doc(id).get();

    if (quiz.exists) {
      commit(SET_QUIZ, {
        id: quiz.id,
        ...quiz.data()
      });
      // If in editMode newQuiz should take the value of quiz we just fetched
      if (editMode == true) {
        // Partial update of existing values
        // This is useful when we add new value into the object, but they are not yet in database (smth like a migration)
        // One could also use Object Assign: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
        // or in ES6 : {...previousObject, override1: "foo", override2: "bar"}
        for(var key in quiz.data()) {
          if(state.newQuiz.hasOwnProperty(key)) {
            state.newQuiz[key] = quiz.data()[key];
          }
        }

      }
    }
  }

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/quiz/index.js